// skipcq: JS-W1028
import { useCallback } from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';

import ReviewDetailsItemRow from './ReviewDetailsItemRow';

function ReviewDetailsListItem({
  item,
  selected,
  showUnreadChip,
  showReviewedWhenZero,
  onSelectItem,
}) {
  const handleClick = useCallback(() => {
    if (typeof onSelectItem === 'function') {
      onSelectItem(item);
    }
  }, [item, onSelectItem]);

  const itemKey = `${item.itemType}:${item.itemId}`;

  return (
    <ListItemButton
      key={itemKey}
      selected={selected}
      onClick={handleClick}
      sx={{ alignItems: 'stretch', py: 1.25, px: 2 }}
    >
      <ReviewDetailsItemRow
        item={item}
        showUnreadChip={showUnreadChip}
        showReviewedWhenZero={showReviewedWhenZero}
      />
    </ListItemButton>
  );
}

ReviewDetailsListItem.propTypes = {
  item: PropTypes.shape({
    itemType: PropTypes.oneOf(['beer', 'brewery']).isRequired,
    itemId: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  selected: PropTypes.bool,
  showUnreadChip: PropTypes.bool,
  showReviewedWhenZero: PropTypes.bool,
  onSelectItem: PropTypes.func,
};

function ReviewDetailsItemList({
  items,
  selectedItemKey,
  showUnreadChip,
  showReviewedWhenZero = false,
  onSelectItem,
}) {
  if (items.length === 0) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography variant="body2" color="text.secondary">
          No items to display.
        </Typography>
      </Box>
    );
  }

  return (
    <List dense disablePadding>
      {items.map((item) => {
        const itemKey = `${item.itemType}:${item.itemId}`;
        const selected = itemKey === selectedItemKey;
        return (
          <ReviewDetailsListItem
            key={itemKey}
            item={item}
            selected={selected}
            showUnreadChip={showUnreadChip}
            showReviewedWhenZero={showReviewedWhenZero}
            onSelectItem={onSelectItem}
          />
        );
      })}
    </List>
  );
}

ReviewDetailsItemList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    itemType: PropTypes.oneOf(['beer', 'brewery']).isRequired,
    itemId: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    averageRating: PropTypes.number,
    unseenCount: PropTypes.number,
    totalCount: PropTypes.number,
  })).isRequired,
  selectedItemKey: PropTypes.string,
  showUnreadChip: PropTypes.bool,
  showReviewedWhenZero: PropTypes.bool,
  onSelectItem: PropTypes.func,
};

export default ReviewDetailsItemList;
